module.exports = __webpack_public_path__ + "img/thumb-010-03.7fffb908.png";